// router.js
import { RouterProvider } from "react-router-dom";
import router from "./utils/Router";
import { Suspense } from "react";

// 🧱 Providers & Layouts
import { ScreenProvider } from "./context/ScreenContext";
import { NotificationProvider } from "./context/NotificationContext";

export default function App() {
  return (
    <ScreenProvider>
      <NotificationProvider>
        <Suspense>
          <RouterProvider router={router} />
        </Suspense>
      </NotificationProvider>
    </ScreenProvider>
  );
}
